import React, { useEffect, useRef, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Hub } from 'aws-amplify/utils'
import { AuthEvents } from '@/auth/types'

const createQueryClient = () =>
    new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                refetchOnMount: false,
                retry: false,
            },
        },
    })

export default function ReactQueryProvider({ children }: { children: React.ReactNode }) {
    const [client, setClient] = useState(() => createQueryClient())
    const clientRef = useRef(client)

    useEffect(() => {
        clientRef.current = client
    }, [client])

    useEffect(() => {
        const onAuthEvent = async (data: any) => {
            const event = data?.payload?.event
            if (event !== AuthEvents.SIGNED_OUT) return
            try {
                await clientRef.current.cancelQueries()
            } catch {
                // noop
            }
            clientRef.current.clear()
            setClient(createQueryClient())
        }

        Hub.listen('auth', onAuthEvent)
        return () => {
            try {
                // best-effort: remove listener if supported
                // @ts-ignore
                Hub.remove?.('auth', onAuthEvent)
            } catch {
                // noop
            }
        }
    }, [])

    return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
